import React, { FC } from "react"

import { Accordion, AccordionControlProps, ActionIcon, Group, Text } from "@mantine/core"
import { IconMinus, IconSunrise, IconSunset } from "@tabler/icons-react"

import { WittyPiScheduleLine } from "../../hooks/useParseSchedule"
import { useLanguage } from "../../../../contexts/language-context"

type OperatingTimeSettingLineControlProps = Omit<AccordionControlProps, "children"> & {
    line: WittyPiScheduleLine
    onRemove: () => void
}

const OperatingTimeSettingLineControl: FC<OperatingTimeSettingLineControlProps> = ({ line, onRemove, ...props }) => {
    const { L } = useLanguage()

    return (
        <Group noWrap>
            <Accordion.Control {...props}>
                {line.type === "interval" ? (
                    <>
                        <Text size="xs" color="dimmed">
                            {L("At set times")}
                        </Text>
                        {line.start?.slice(0, 5)} – {line.end?.slice(0, 5)}
                    </>
                ) : line.preBuffer !== undefined && line.postBuffer !== undefined ? (
                    <>
                        <Text size="xs" color="dimmed">
                            {line.type === "sunrise"
                                ? L("Around sunrise")
                                : line.type === "sunset"
                                ? L("Around sunset")
                                : L("Before sunrise, after sunset")}
                        </Text>
                        <Group spacing="xs" noWrap>
                            -{line.preBuffer.toString()}min
                            {(line.type === "sunrise" || line.type === "both") && <IconSunrise size={20} />}
                            {(line.type === "sunset" || line.type === "both") && <IconSunset size={20} />}+
                            {line.postBuffer.toString()}
                            min
                        </Group>
                    </>
                ) : (
                    <Text color="dimmed">{L("Choose an option")}</Text>
                )}
            </Accordion.Control>
            <ActionIcon variant="default" m="xs" onClick={onRemove}>
                <IconMinus size={18} />
            </ActionIcon>
        </Group>
    )
}

export default OperatingTimeSettingLineControl
